<template>
  <v-checkbox v-model="profile.willingToRelocateInternationally"
              :label="`I am willing to relocate internationally`"
              @change="submit" :color="themes.candidate.light.input">
  </v-checkbox>
</template>

<script>
// Vue Component
export default {
  props: ['value'],
  data() {
    return {
      // Model (object sent to API)
      profile: {
        willingToRelocateInternationally: this.value
      }
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('candidate/profile/update', this.profile)
    }
  }
}
</script>
